import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import messages from './messages';
import { PaginationDetailsStyled } from './styled';
export var PaginationDetails = function PaginationDetails(_ref) {
  var itemsCount = _ref.itemsCount,
      totalCount = _ref.totalCount;
  return /*#__PURE__*/React.createElement(PaginationDetailsStyled, {
    "data-testid": "paginated-picker.ui.async-select.pagination-details"
  }, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.ofTotalCount, {
    values: {
      itemsCount: itemsCount,
      totalCount: totalCount
    }
  })));
};
export default PaginationDetails;